import { formatPrice } from "@/lib/api";

const PriceDetails = ({ totalMrp, discount, delivery, payable, totalQty, codFee = 0, actionLabel, onAction, actionTestId }) => (
  <div className="bg-white rounded-sm fk-shadow" data-testid="price-details">
    <p className="text-[#878787] font-semibold uppercase text-sm px-4 py-3 border-b border-[#f0f0f0]">
      Price Details
    </p>
    <div className="px-4 py-3 space-y-3 text-sm text-[#212121]">
      <div className="flex justify-between">
        <span>Price ({totalQty} item{totalQty > 1 ? "s" : ""})</span>
        <span>{formatPrice(totalMrp)}</span>
      </div>
      <div className="flex justify-between">
        <span>Discount</span>
        <span className="text-[#388e3c]">− {formatPrice(discount)}</span>
      </div>
      <div className="flex justify-between">
        <span>Delivery Charges</span>
        <span className={delivery === 0 ? "text-[#388e3c]" : ""}>
          {delivery === 0 ? "FREE" : formatPrice(delivery)}
        </span>
      </div>
      {codFee > 0 && (
        <div className="flex justify-between" data-testid="cod-fee-row">
          <span>COD Fee (12%)</span>
          <span>{formatPrice(codFee)}</span>
        </div>
      )}
      <div className="flex justify-between border-t border-dashed border-[#e0e0e0] pt-3 text-base font-semibold">
        <span>Total Amount</span>
        <span data-testid="price-total">{formatPrice(payable + codFee)}</span>
      </div>
    </div>
    <p className="text-[#388e3c] font-semibold text-sm px-4 py-3 border-t border-dashed border-[#e0e0e0]" data-testid="savings-banner">
      You will save {formatPrice(discount)} on this order
    </p>
    {actionLabel && (
      <div className="px-4 pb-4">
        <button
          onClick={onAction}
          className="w-full bg-[#fb641b] text-white font-semibold h-11 rounded-sm hover:brightness-95 transition"
          data-testid={actionTestId}
        >
          {actionLabel}
        </button>
      </div>
    )}
  </div>
);

export default PriceDetails;
